require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./strayas-finest-passion-fruit-and-tropical-crunch.json") })
        }
      }, "path---strayas-finest-passion-fruit-and-tropical-crunch");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---strayas-finest-passion-fruit-and-tropical-crunch!./.cache/json/strayas-finest-passion-fruit-and-tropical-crunch.json
// module id = 494
// module chunks = 231608221292675